import { TCompanyData } from '@commenda/types/src/company/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useCompanyData(
  companyId: number | string,
  token?: string
) {
  const url = companyId ? `company/${companyId}` : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TCompanyData;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    url,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  const corporations = data?.corporations;

  return {
    data,
    corporations,
    error,
    mutate,
  };
}
